import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AdminRepositoryService } from 'src/app/services/admin-repository.service';
import { DocumentsRepositoryService } from 'src/app/services/documents-repository.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { Role } from 'src/app/shared/models/user.model';
import { FormsConfirmationMessageComponent } from 'src/app/solar-forms/dialogs/forms-confirmation-message/forms-confirmation-message.component';

@Component({
  selector: 'app-mass-communications',
  templateUrl: './mass-communications.component.html',
   styleUrls: ['./mass-communications.component.scss']
})
export class MassCommunicationsComponent implements OnInit {

  massCommunicationForm: UntypedFormGroup;
  isLoadingData: boolean;
  tooltipOptions: Object;
  selectedOptions = new UntypedFormControl([]);
  options = ['Option 1', 'Option 2', 'Option 3', 'Option 4'];
  private unsubscribe: Subject<void> = new Subject<void>();
  roles: Role[];
  fileList = [];
  maxFileList: boolean;
  duplicateFiles: boolean;
  massDATA: FormData;
  filesArray: any;
  fileSizeValid: boolean;
  fileSize: any;
  acceptedFileExtensions: string[];
  extensionValid: boolean;

  constructor(
    private dialogRef: MatDialogRef<MassCommunicationsComponent>,
    private fb: UntypedFormBuilder,
    private userRepository: UserRepositoryService,
    private adminRepository: AdminRepositoryService,
    private documentsService: DocumentsRepositoryService,
    private dialog: MatDialog,
    private snackBarService: SnackBarService,
  ) { }

  ngOnInit(): void {
    this.massCommunicationInit();
    this.getAllRoles();
    this.validateFileSize();
    this.getValidFileExtensions();
  }

  massCommunicationInit() {
    this.massCommunicationForm = this.fb.group({
      userRoles: this.fb.control('', [Validators.required]),
      subject: this.fb.control('', [Validators.required]),
      body: this.fb.control('', [Validators.required]),
      filesAttachment: this.fb.control('')
    });
  }

  getAllRoles() {
    this.isLoadingData = true;
    this.userRepository.getAllRoles()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((roles: Role[]) => {
        if (roles) {
          this.roles = roles;
          this.isLoadingData = false;
        }
      }, err => {
        this.isLoadingData = false;
      });
  }

  onFileSelected(event) {
    const files = event.target.files;
    if(files) {
    const selectedFileSize = files[0].size;
    const fileSizeInKB = Math.round(selectedFileSize / 1024);
    const fileSizeInMB = Math.round(fileSizeInKB / 1024);
    this.fileSizeValid = fileSizeInMB >= this.fileSize ? true : false;
    this.fileExtensionValidator(files);
      for(let i=0; i < files.length; i++) {
        if(this.fileList.length < 3 && !this.fileSizeValid && !this.extensionValid) {
          this.fileList.push(files[i]);
          if(this.fileList.length == 3) {
            this.maxFileList = true;
          }
        }      
      }
    }
  }

  fileExtensionValidator(currentFile) {   
    let abc = currentFile[0].name.split('.');
    let fileExtensionValue = currentFile[0].name.split('.');
    let fileExtensionValueWithdot = '.'+fileExtensionValue[1];
    if((this.acceptedFileExtensions.indexOf(fileExtensionValue[1].toString()) > -1) || (this.acceptedFileExtensions.indexOf(fileExtensionValueWithdot.toString()) > -1)) {
      this.extensionValid = false;
    } else {
      this.extensionValid = true;
    }
  }

  private getValidFileExtensions(): void {
    this.acceptedFileExtensions = [];
    this.documentsService
      .getValidFileExtensions()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (response) => {
          if(response) {
            this.acceptedFileExtensions = response;
          }
        },
        (error) => {
          this.snackBarService.showError(error.message);
        }
      );
  };

  validateFileSize() {
    this.adminRepository.getfileSize()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((response: number) => {
        if(response) {
          this.fileSize = response;
        }
      });
  }

  fileUpload() {
    document.getElementById("filesUpload").click();
  }

  removeFileFromList(index) {
      this.fileList.splice(index, 1);
      if(this.fileList.length <= 2) {
        this.maxFileList = false;
      }
  }

  onSaveClick() {
    if(this.massCommunicationForm.valid) {
      let massCommDetails = {
        roleName: this.userRoles.value,
        subject: this.subject.value,
        mailBody: this.body.value,
        attachments: this.fileList
      }
      let messageInfo = {
        data: massCommDetails,
        isMassComm: true,
        name: 'Send Mass Communication Email',
        message: 'Do you wish to send this email to the roles:',
      }
        const dialogR = this.dialog.open(FormsConfirmationMessageComponent, {
          width: '550px',
          data: messageInfo
        });
      
        dialogR.afterClosed().pipe(takeUntil(this.unsubscribe))
        .subscribe(result => {
          if(result) {
            this.dialogRef.close();
          }
        });
    }
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  get userRoles() {
    return this.massCommunicationForm.get('userRoles') as UntypedFormControl;
  }

  get subject() {
    return this.massCommunicationForm.get('subject') as UntypedFormControl;
  }

  get body() {
    return this.massCommunicationForm.get('body') as UntypedFormControl;
  }

}
